<template>
  <q-item
    clickable
  >
    <q-item-section no-wrap>
      {{ name }}
    </q-item-section>
    <q-item-section side>
      <q-icon name="keyboard_arrow_right" />
    </q-item-section>

    <q-menu
      anchor="top end"
      self="top start"
    >
      <q-list>
        <q-item
          v-for="option in options"
          :key="option.value"
          v-close-popup
          clickable
          :active="option.value === modelValue"
          @click="selectValue(option.value)"
        >
          <q-item-section side>
            <q-icon
              color="primary"
              :name="option.value === modelValue ? 'check' : ''"
            />
          </q-item-section>
          <q-item-section no-wrap>
            {{ option.label }}
          </q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-item>
</template>

<script>

export default {
  name: 'SubmenuOptions',
  props: {
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Boolean, Number],
      required: true
    }
  },
  emits: ['update:model-value'],
  methods: {
    selectValue (value) {
      this.$emit('update:model-value', value)
    }
  }

}

</script>
